<template>
  <div class="custom-select" v-click-outside="closeSearch">
    <input type="text" @click.prevent="openSelectView()"  v-model="inputValue">
    <a v-if="showSelectAll()" href="#" @click.prevent="addAllOptions" class="select-all btn btn-outline-primary btn-sm">{{ $t('checklist.add_to_checklist_modal.select_all')}}</a>
    <div v-if="optionsToBeDeleted.length > 0" v-bind:class="singleSelectOption">
      <ul>
        <li :id="item.id" v-for="item in optionsToBeDeleted" :key="item.id">
          <span @click="remove(item)">x</span>
          {{template(item)}}
        </li>
      </ul>
      <a v-if="optionsToBeDeleted.length > 0 && !singleSelect" href="#" @click.prevent="clearSelectOption" class="remove-all">{{ $t('checklist.add_to_checklist_modal.remove_all')}}</a>
    </div>
    <ul v-if="openSelect" class="options-list">
      <li
        @click.prevent="add(option)"
        v-for="option in options"
        :key="option.id"
        :id="option.id">{{template(option)}}
      </li>
      <li v-if="optionsForSelect.length === 0">{{ $t('checklist.add_to_checklist_modal.no_options_added')}}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'PinkCatSelect',
    props: {
      loadAsync: {type: Function},
      template: {type: Function},
      singleSelect: {type: Boolean, default: false},
      optionsForSelect: {type: Array | Function},
      selectedFilters: {type: Array | Function},
    },
    data() {
      return {
        inputValue: '',
        openSelect: false
      }
    },
    computed: {
      options() {
        if (this.optionsForSelect) {
          return this.optionsForSelect.filter(f => {
            return f.name.toLowerCase().includes(this.inputValue)
          })
        } else {
          return []
        }
      },
      optionsToBeDeleted() {
        return this.selectedFilters
      },
      singleSelectOption() {
        if(this.singleSelect) {
          return ' selected-option single-selected-option'
        } else {
          return 'selected-option'
        }
      }
    },
    methods: {
      openSelectView() {
        this.openSelect = true
        this.$props.loadAsync && this.loadAsync()
      },
      closeSearch() {
        this.openSelect = false
      },
      add(option) {
        if(this.singleSelect) {
          this.openSelect = false
          this.inputValue = ''
        }
        this.$emit('add', option)
      },
      remove(option) {
        if(this.singleSelect) {
          this.openSelect = false
        }
        this.inputValue = ''
        this.$emit('remove', option)
      },
      clearSelectOption() {
        this.openSelect = false
        this.inputValue = ''
        this.$emit('clearSelectedOption')
      },
      showSelectAll() {
        return this.openSelect && !this.singleSelect && this.optionsForSelect.length > 0
      },
      addAllOptions() {
        this.options.forEach(o => this.add(o))
      },
      getInputValue() {
        return this.inputValue
      },
    }
  }
</script>

<style lang='sass' scoped>
  @import "../../styles/select"
</style>
